import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenService } from '../services/token/token.service';
import { LoginService } from '../../features/login/login.service';

@Injectable()

export class TokenInterceptor implements HttpInterceptor {

  constructor(public tokenService: TokenService, public loginService: LoginService) {}

  accessToken = '';

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    /* this.loginService.accessToken.subscribe((response: any) => {
      this.accessToken = response;
    }); */

    const accessToken = this.loginService.accessToken.getValue();

    if(accessToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    }

    return next.handle(request);
  }
  
}